import api from '../lib/utils/apiConfig';

const blogService = {
  getBlogs: async () => {
    const response = await api.get('/blogs');
    return response.data;
  },

  getBlogById: async (id) => {
    const response = await api.get(`/blogs/id/${id}`);
    return response.data;
  },

  createBlog: async (data) => {
    const response = await api.post('/blogs', data);
    return response.data;
  },

  updateBlog: async (id, data) => {
    const response = await api.put(`/blogs/${id}`, data);
    return response.data;
  },

  deleteBlog: async (id) => {
    const response = await api.delete(`/blogs/${id}`);
    return response.data;
  },

  updateBlogStatus: async (id, status) => {
    const response = await api.patch(`/blogs/${id}/status`, { status });
    return response.data;
  },
};

export default blogService;
